export const PROJECT_MEMBER_LIMIT = 5;
export const DEFAULT_CURRENCY = 'RUB';
export const SUPPORTED_CURRENCIES = [
    'RUB',
    'USD',
    'EUR',
    'KZT',
    'BTC',
    'TON',
    'USDT',
];
export const CRYPTO_CURRENCIES = ['BTC', 'TON', 'USDT'];
// Категории для планирования бюджета (рекомендованная база)
export const BUDGET_CATEGORIES = [
    'Ремонтные работы',
    'Черновые материалы',
    'Чистовая отделка',
    'Встроенная мебель',
    'Отдельная мебель',
    'Кухонная техника',
    'Бытовая техника и электроника',
    'Сантехника',
    'Инженерные системы',
    'Освещение',
    'Текстиль и декор',
    'Прочее / Резерв',
];
// Двухуровневая структура категорий расходов
export const EXPENSE_CATEGORIES = {
    'Стройматериалы': [
        'Материалы',
        'Черновые материалы',
        'Отделка',
        'Плитка',
        'Полы',
        'Потолки',
        'Окна и двери',
        'Краска',
        'Обои',
        'Сухие смеси и штукатурка',
        'Гипсокартон и профиль',
        'Изоляция и гидроизоляция',
        'Крепёж и расходники',
        'Кабель и электроматериалы',
        'Трубы и фитинги',
        'Плинтусы и молдинги',
    ],
    'Работы': [
        'Демонтаж',
        'Черновые работы',
        'Отделочные работы',
        'Монтажные работы',
        'Электромонтаж',
        'Сантехмонтаж',
        'Плиточные работы',
        'Малярные работы',
        'Потолочные работы',
        'Напольные работы',
        'Установка окон и дверей',
        'Сборка и установка мебели',
    ],
    'Техника и оборудование': [
        'Сантехника',
        'Электрика',
        'Вентиляция',
        'Отопление',
        'Освещение',
        'Мебель',
        'Техника',
        'Кондиционеры',
        'Бытовая техника',
        'Кухонная техника',
        'Умный дом и слаботочка',
    ],
    'Услуги': [
        'Доставка',
        'Проектирование',
        'Разрешения',
        'Консультации',
        'Дизайн-проект',
        'Замеры',
        'Аренда инструмента и техники',
        'Вывоз мусора',
        'Клининг после ремонта',
        'Грузчики и подъём',
        'Технадзор',
    ],
    'Прочее': [
        'Инструменты',
        'Декор',
        'Резерв на непредвиденное',
        'Коммунальные платежи',
        'Аренда жилья на время ремонта',
        'Прочее',
    ],
};
// Категории расходов для финансовых проектов
export const FINANCE_EXPENSE_CATEGORIES = {
    'Еда и продукты': [
        'Продукты',
        'Рестораны и кафе',
        'Доставка еды',
    ],
    'Транспорт': [
        'Топливо',
        'Общественный транспорт',
        'Такси',
        'Обслуживание авто',
        'Парковка',
    ],
    'Жильё и ЖКУ': [
        'Аренда',
        'Ипотека',
        'Коммунальные услуги',
        'Интернет и связь',
        'Ремонт и обслуживание',
    ],
    'Здоровье': [
        'Врачи и клиники',
        'Лекарства',
        'Спорт и фитнес',
        'Страховка',
    ],
    'Развлечения': [
        'Подписки',
        'Кино и театр',
        'Хобби',
        'Игры',
    ],
    'Одежда и уход': [
        'Одежда и обувь',
        'Уход за собой',
    ],
    'Образование': [
        'Курсы и обучение',
        'Книги',
        'Детское образование',
    ],
    'Техника и гаджеты': [
        'Смартфон',
        'Ноутбук',
        'Планшет',
        'Наушники',
        'Аксессуары',
        'Прочее',
    ],
    'Маркетплейсы': [
        'Ozon',
        'Wildberries',
        'Яндекс.Маркет',
    ],
    'Путешествия': [
        'Билеты',
        'Жильё',
        'Трансфер',
    ],
    'Кофе': [
        'Кофейня',
        'Кофе навынос',
    ],
    'Прочее': [
        'Подарки',
        'Благотворительность',
        'Прочее',
    ],
};
// ─── Вложения (сметы, фото, чеки) ──────────────────────────────────────────
export const ATTACHMENT_IMAGE_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
    'image/heif',
];
export const ATTACHMENT_DOC_MIME_TYPES = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    'application/vnd.ms-excel', // xls
    'text/csv',
];
export const ATTACHMENT_ALLOWED_MIME_TYPES = [
    ...ATTACHMENT_IMAGE_MIME_TYPES,
    ...ATTACHMENT_DOC_MIME_TYPES,
];
/** Форматы, которые умеет разбирать клиентский парсер сметы (Slice 7) — только табличные. */
export const ATTACHMENT_SPREADSHEET_MIME_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'text/csv',
];
export const ATTACHMENT_MAX_SIZE_BYTES = 15 * 1024 * 1024;
export const ATTACHMENT_MAX_PER_EXPENSE = 10;
export const ATTACHMENT_MAX_PER_PROJECT = 60;
/** Фото товаров считаются отдельно: иначе пара подборок съела бы квоту смет и галереи. */
export const ATTACHMENT_MAX_NEED_OPTION_PHOTOS = 500;
/** Второй, независимый от Garage layout capacity предохранитель от заполнения диска VPS. */
export const ATTACHMENT_MAX_PROJECT_BYTES = 500 * 1024 * 1024;
export const ATTACHMENT_IMAGE_MAX_DIMENSION = 1920;
export const ATTACHMENT_URL_TTL_SECONDS = 3600;
export const ATTACHMENT_UPLOAD_TTL_SECONDS = 300;
//# sourceMappingURL=constants.js.map